import { useEffect, useRef } from 'react';
import { useSelector, useStore } from 'react-redux';

import { getPollingInterval } from '../../../../util';
import { logChatbotGeneralClientLog } from '../../../bi/loggers/logChatbotGeneralClientLog';
import {
  selectIsLiveChat,
  selectItems,
  selectLastNonClientOnlyMessageId,
} from '../../../common/selectors/chat';
import { selectUserId } from '../../../common/selectors/user';
import { messagesPolling } from '../../../util/live-chat-polling';

export const usePolling = () => {
  const lastMessageId = useSelector(selectLastNonClientOnlyMessageId);
  const userId = useSelector(selectUserId);
  const isLiveChat = useSelector(selectIsLiveChat);
  // a special event for debugging. will be removed after CCR-3146 will be resolved
  const items = useSelector(selectItems);
  const store = useStore();
  // a special event for debugging. will be removed after CCR-3146 will be resolved
  useEffect(() => {
    if (isLiveChat) {
      logChatbotGeneralClientLog(store.getState(), {
        message: 'Render live chat items',
        data: { isLiveChat, items },
      });
    }
  }, [items, isLiveChat]);

  // Store latest props in a ref to access in polling effect,
  // because we can't specify them in deps as the effect would be called too often
  const latestProps = useRef({
    lastMessageId,
    userId,
  });

  useEffect(() => {
    latestProps.current = {
      lastMessageId,
      userId,
    };
  });

  useEffect(() => {
    if (!latestProps.current.userId || isLiveChat) {
      const interval = getPollingInterval(Boolean(window.isTest), latestProps.current.userId);
      return messagesPolling.start(latestProps.current.lastMessageId!, interval);
    }
    return messagesPolling.stop();
  }, [isLiveChat]);
};
